module.exports = __webpack_public_path__ + "media/images/top/seminars/template/image10-ce544353fa93c92eb719adaa26cb9ee5.jpeg";